import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import type { UserRole } from "@hybrid-escrow/shared";
import { useAuthPrincipal } from "../hooks/useAuthPrincipal";
import { LoadingState } from "./States";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { isInitialized, isSignedIn } = useAuthPrincipal();
  const location = useLocation();

  if (!isInitialized) return <LoadingState label="Checking your session…" />;
  if (!isSignedIn) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

export function RequireRole({ roles, children }: { roles: UserRole[]; children: ReactNode }) {
  const { isInitialized, isSignedIn, principal, isLoadingPrincipal } = useAuthPrincipal();

  if (!isInitialized || (isSignedIn && isLoadingPrincipal)) {
    return <LoadingState label="Checking your permissions…" />;
  }
  if (!isSignedIn) {
    return <Navigate to="/sign-in" replace />;
  }
  if (!principal || !roles.includes(principal.role)) {
    return (
      <div className="alert alert--danger" role="alert">
        <strong>Restricted area.</strong>
        <p>You don&apos;t have permission to view this page.</p>
      </div>
    );
  }
  return <>{children}</>;
}
